import { useState } from "react";
import Sidebar from "./sidebar";
import Content from "./content";


const ThemeBuilder = (props) => {
    const { themeBuilderMenu } = window['JkitDashboardOption'];

    const [activeMenu, setActiveMenu] = useState(themeBuilderMenu[0].submenu[0].slug);

    const attr = {
        activeMenu,
        setActiveMenu,
        menus: themeBuilderMenu,
        ...props
    };

    return <div className="f-theme-wrapper">
        <Sidebar {...attr} />
        <Content {...attr} />
    </div>;
};

export default ThemeBuilder;
